import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const emailRegex =
  /^([\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*)@((?:[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?\.)+[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?)$/;
const firstSpace = /^(?!\s).*/;
const passwordRegexSpecial =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
const phoneRegex = /^(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

export const signupValidationSchema = yupResolver(
  Yup.object().shape({
    userName: Yup.string().required("Please enter your name"),
    LoginEmail: Yup.string()
      .required("Please enter your email")
      .matches(emailRegex, "Please enter valid email"),
    password: Yup.string()
      .required("Please enter your password")
      .matches(firstSpace, "Enter valid Password")
      .matches(passwordRegexSpecial, "Enter valid Password"),
    // confirmPassword: Yup.string()
    //   .oneOf([Yup.ref("password")], "Passwords must match")
    //   .required("Confirm Password is required"),
  })
);

export const loginValidationSchema = yupResolver(
  Yup.object().shape({
    LoginEmail: Yup.string()
      .required("Please enter your email")
      .matches(emailRegex, "Please enter valid email"),
    password: Yup.string()
      .required("Please enter your password")
      .matches(firstSpace, "Enter valid Password")
      .matches(passwordRegexSpecial, "Enter valid Password"),
    // confirmPassword: Yup.string()
    //   .oneOf([Yup.ref("password")], "Passwords must match")
    //   .required("Confirm Password is required"),
  })
);

export const changePasswordValidationSchema = yupResolver(
  Yup.object().shape({
    oldPassword: Yup.string().required("Please enter your old password"),
    newPassword: Yup.string()
      .required("Please enter your new password")
      .matches(firstSpace, "Enter valid Password")
      .matches(passwordRegexSpecial, "Enter valid Password"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords must match")
      .required("Confirm Password is required"),
  })
);

export const profileValidationSchema = yupResolver(
  Yup.object().shape({
    firstName: Yup.string().required("Please enter your First Name"),
    lastName: Yup.string().required("Please enter your Last Name"),
    email: Yup.string()
      .required("Please enter your email")
      .matches(emailRegex, "Please enter valid email"),
  })
);

export const orderBillingValidationSchema = yupResolver(
  Yup.object().shape({
    firstName: Yup.string().required("Please enter your First Name"),
    lastName: Yup.string().required("Please enter your Last Name"),
    phoneNumber: Yup.string()
      .required("Please enter your Phone Number")
      .matches(phoneRegex, "Please enter valid phone"),
    email: Yup.string()
      .required("Please enter your email")
      .matches(emailRegex, "Please enter valid email"),
    address: Yup.string().required("Please enter your Address"),
    country: Yup.string().required("Please enter your Country"),
    state: Yup.string().required("Please enter your State"),
    zipcode: Yup.string().required("Please enter your Zip Code"),
  })
);

export const addProductValidationSchema = yupResolver(
  Yup.object().shape({
    productName: Yup.string().required("Product name is required"),
    productDescription: Yup.string().required(
      "Product description is required"
    ),
    price: Yup.number()
      .required("Price is required")
      .positive("Price must be a positive number"),
    productCategory: Yup.string().required("Product category is required"),
    productType: Yup.string().required("Product type is required"),
    salePrice: Yup.number()
      .required("Sale price is required")
      .min(0, "Sale price cannot be negative")
      .max(
        Yup.ref("price"),
        "Sale price cannot be more than the regular price"
      ),
    stockQuantity: Yup.number()
      .required("Stock quantity is required")
      .integer("Stock quantity must be an integer")
      .min(1, "Stock quantity must be at least 1"),
    skuNumber: Yup.string().required("SKU number is required"),
    featuredImage: Yup.array()
      .of(Yup.string().url("Invalid image URL"))
      .min(1, "At least one featured image is required"),
    selectedSizes: Yup.array()
      .of(Yup.string().required("Size is required"))
      .min(1, "At least one size must be selected"),
    selectedColors: Yup.array()
      .of(Yup.string().required())
      .min(1, "At least one color must be selected"),
  })
);
